import { toJS } from '../../_snowpack/pkg/mobx.js';
import { useMutation } from '../../_snowpack/pkg/react-query.js';
import api from '../api/index.js';
import { queryClient, store } from '../stores/index.js';
export function useUpdateOrder() {
  return useMutation(api.updateOrder, {
    onSuccess: data => {
      let tags = toJS(store.tags);
      queryClient.setQueryData(['orders', store.getFilter()], dataSource => {
        return {
          ...dataSource,
          items: dataSource.items.map(oldOrder => {
            let order = {
              ...oldOrder
            };
            if (oldOrder.id === data.id) {
              order.status = data.status;
              order.tags = tags.filter(x => data.tags.includes(x.value)).map(x => ({
                id: x.value,
                name: x.label
              }));
              order.orderNotes = data.orderNotes.slice(0, 2);
            }
            return order;
          })
        };
      });
    }
  });
}